export const isCTAE = (): boolean => {
    if (typeof window === 'undefined') return false
    const host = window.location.hostname.toLowerCase()
    return host.includes('cleartrip.ae') || host.includes('me.cleartrip.ae')
}

export default isCTAE
